module.exports = __webpack_public_path__ + "static/media/blue-bg.7e6770c9.png";